import { useAuth } from '@/features/auth/authContext'
import { isSwitchAllowed } from '@/hooks/useSwitch'

const INVITING_ROLES: ReadonlySet<string> = new Set([
  'branch_manager',
  'franchise_partner',
  'company_admin',
])

export function roleCanInvite(roleKey: string | undefined): boolean {
  return roleKey !== undefined && INVITING_ROLES.has(roleKey)
}

/**
 * Inviting is `USER_INVITE`, held by `branch_manager`, `franchise_partner` (it
 * implies `branch_manager`) and `company_admin`; everyone
 * else gets a 403 `CAPABILITY_REQUIRED`, so offering them the button only invites a
 * failure.
 *
 * This hides the action; it does not replace handling the 403. The server
 * decides, and a role can change under a tab that has been open for hours.
 */
/** As `roleCanInvite`, and at least one of the Standort's two invite switches still on. */
export function roleCanInviteWith(
  roleKey: string | undefined,
  switches: Record<string, boolean> | undefined,
): boolean {
  return (
    roleCanInvite(roleKey) &&
    (isSwitchAllowed(switches, 'INVITE_STAFF') || isSwitchAllowed(switches, 'INVITE_MANAGER'))
  )
}

export function useCanInviteUsers(): boolean {
  const { role, session } = useAuth()
  return roleCanInviteWith(role?.key, session?.switches)
}
